<div class="popup-container">
    <div class="popup-header">
        <h3 class="m-0">Applica transito</h3>
    </div>

    <div class="popup-body text-center py-4" *ngIf="step === 'checking'">
        <i class="fas fa-spinner fa-spin me-2"></i>Verifica dei colli...
    </div>

    <div class="popup-body" *ngIf="step === 'select'">
        <p class="text-muted small mb-3">
            <ng-container *ngIf="data.comParcelsList.length === 1; else manyParcels">Il collo selezionato passerà</ng-container>
            <ng-template #manyParcels>I {{ data.comParcelsList.length }} colli selezionati passeranno</ng-template>
            in transito dal magazzino scelto prima di proseguire verso la destinazione attuale.
        </p>
        <div class="mb-3">
            <label class="form-label fw-bold">Magazzino di transito</label>

            <ng-select
                class="filter-ng-select"
                [items]="availableTransitWarehouses"
                bindLabel="warehouseName"
                bindValue="warehouseCode"
                [(ngModel)]="transitWarehouseCode"
                [clearable]="true"
                [searchable]="true"
                [searchFn]="searchWarehouseFn"
                [loading]="loadingWarehouses && availableTransitWarehouses.length === 0"
                appendTo="body"
                placeholder="Seleziona un magazzino"
                loadingText="Caricamento..."
                notFoundText="Nessun magazzino di transito disponibile per i colli selezionati">

                <ng-template ng-option-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-warehouse me-2"></i>
                        <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                    </span>
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-warehouse me-2"></i>
                        <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                    </span>
                </ng-template>
            </ng-select>
        </div>

        <div class="mb-3">
            <label class="form-label fw-bold">Vettore</label>

            <ng-select
                class="filter-ng-select filter-ng-select-carrier"
                [items]="availableCarriers"
                bindLabel="carrierName"
                bindValue="carrierCode"
                [(ngModel)]="carrierCode"
                [clearable]="false"
                [searchable]="true"
                [searchFn]="searchCarrierFn"
                appendTo="body"
                placeholder="Seleziona un vettore"
                loadingText="Caricamento..."
                notFoundText="Nessun vettore nei gruppi del magazzino">

                <ng-template ng-option-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-truck me-2"></i>
                        <span>{{ item.carrierName }}</span>
                    </span>
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-truck me-2"></i>
                        <span>{{ item.carrierName }}</span>
                    </span>
                </ng-template>
            </ng-select>
        </div>

        <div *ngIf="!loadingWarehouses && !error && availableTransitWarehouses.length === 0" class="alert alert-secondary py-2 small mb-0">
            Nessun magazzino di transito disponibile: i colli selezionati passano già da tutti i magazzini di transito configurati.
        </div>

        <div *ngIf="error" class="alert alert-danger py-2 small mb-0">
            {{ error }}
        </div>
    </div>

    <div class="popup-body" *ngIf="step === 'warning'">
        <div class="alert alert-warning mb-3">
            <div class="fw-bold mb-2">
                <i class="fas fa-exclamation-triangle me-2"></i>Attenzione
            </div>
            <div class="mb-2">Alcuni colli delle stesse bolle sono già in viaggio:</div>
            <ul class="mb-0 ps-3 trip-groups-list">
                <li *ngFor="let group of parcelsInTripGroups">
                    viaggio <b>{{ group.tripCode }}</b> in direzione <b>{{ group.destinationName }}</b>
                    ({{ group.count }} {{ group.count === 1 ? 'collo' : 'colli' }})
                </li>
            </ul>
        </div>

        <button type="button" class="btn btn-sm btn-outline-secondary mb-3" (click)="openParcelsInTripDialog()">
            <i class="fas fa-info-circle me-1"></i> Info
        </button>

        <div class="small">
            Applicare il transito
            <ng-container *ngIf="data.comParcelsList.length === 1; else manyParcelsConfirm">solo al collo selezionato?</ng-container>
            <ng-template #manyParcelsConfirm>solo ai {{ data.comParcelsList.length }} colli selezionati?</ng-template>
        </div>
    </div>

    <div class="popup-footer d-flex justify-content-start gap-2" *ngIf="step === 'checking'">
        <button type="button" class="btn btn-light" (click)="cancel()">
            <i class="fas fa-times me-2"></i>
            Annulla
        </button>
    </div>

    <div class="popup-footer d-flex justify-content-between gap-2" *ngIf="step === 'select'">
        <button type="button" class="btn btn-light" (click)="cancel()">
            <i class="fas fa-times me-2"></i>
            Annulla
        </button>

        <button type="button" class="btn btn-primary" [disabled]="!transitWarehouseCode || !carrierCode" (click)="confirm()">
            <i class="fas fa-check me-2"></i> Applica transito
        </button>
    </div>

    <div class="popup-footer d-flex justify-content-between gap-2" *ngIf="step === 'warning'">
        <button type="button" class="btn btn-light" (click)="cancel()">
            <i class="fas fa-times me-2"></i>
            No
        </button>

        <button type="button" class="btn btn-warning" (click)="continueAfterWarning()">
            OK, continua <i class="fas fa-arrow-right ms-2"></i>
        </button>
    </div>
</div>
